import React from 'react'
import {connect, store} from 'react-redux'
import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { Modal, Tabs, Input, Tree } from 'antd';
import log from 'components/utils/Logger.js'
import * as Actions from '../../redux/actions';
import {generate} from "../../components/utils/TreeDataGenerator";

const TreeNode = Tree.TreeNode;



const getParentKey = (uuid, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.uuid === uuid)) {
                parentKey = node.uuid;
            } else if (getParentKey(uuid, node.children)) {
                parentKey = getParentKey(uuid, node.children);
            }
        }
        log.debug(node.uuid ,"node_uuid");
        log.debug(node.name, "node_name");
    }
    return parentKey;
};


const dataList = [];
const generateList = (data) => {
    //一旦初期化
    for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const uuid = node.uuid;
        dataList.push({uuid, name:node.name});
        if (node.children) {
            generateList(node.children);
        }
    }
    return dataList;
};


const mapStateToProps = (state, props) => {
    return {
        screen: state.screen,
        group: state.group,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        searchGroup: () => {
            dispatch(Actions.AdminConnection.group.search.request());
        }
    }
};


class AddGroupModal extends React.Component {
    constructor(props) {
        super(props);
        let loading = true;

        let groupListArray = [];
        let groupListSearchIndexArray = [];
        if (!props.group.meta.fetch) {
            if (!props.group.error) {
                if (props.group.payload !== null && props.group.payload.hasOwnProperty("result") && props.group.payload.result.hasOwnProperty("items")) {
                    groupListArray = props.group.payload.result.items;
                    dataList.splice(0,dataList.length);
                    groupListSearchIndexArray = generateList(groupListArray)
                }
            }
        } else {
            loading =  props.group.meta.fetch
        }
        this.state = {
            visible: props.visible,
            expandedKeys: [],
            checkedKeys: [],
            checkedRows: [],
            loading,
            searchValue: '',
            autoExpandParent: true,
            groupListArray,
            groupListSearchIndexArray,
        }
    }

    componentWillMount(){
        this.props.searchGroup();
    }


    componentWillReceiveProps(nextProps) {

        const {group,checkedKeys} = {...this.props};

        if(this.state.visible === false) {
            this.setState({
                expandedKeys: [],
                checkedKeys: [],
                checkedRows: [],
            });
        }

        this.setState({
            checkedKeys: nextProps.checkedKeys,
            visible :nextProps.visible,
        });

        if (nextProps.group !== group) {
            if (!nextProps.group.meta.fetch) {
                if (!nextProps.group.error) {
                    if (nextProps.group.payload !== null) {
                        dataList.splice(0,dataList.length);
                        this.setState({
                            loading: nextProps.group.meta.fetch,
                            groupListArray: nextProps.group.payload.result.items,
                            groupListSearchIndexArray: generateList( nextProps.group.payload.result.items)
                        })
                    }
                }
            } else {
                this.setState({
                    loading: nextProps.group.meta.fetch
                })
            }
        }
    }


    handleOk = () => {
        log.debug(this.state.checkedKeys,"checkedKeys");
        log.debug(this.state.checkedRows,"checkedRows");
        this.props.handleOk(this.state.checkedKeys,this.state.checkedRows);
        this.setState({
            confirmLoading: true,
        });
        setTimeout(() => {
            this.setState({
                confirmLoading: false,
            });
        }, 2000);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };


    //ここから

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

    onChange = (e) => {
        const value = e.target.value;
        const expandedKeys = this.state.groupListSearchIndexArray.map((item) => {
            if (item.name.indexOf(value) > -1) {
                return getParentKey(item.uuid, this.state.groupListArray);
            }
            return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i);
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });

    };

    onSelect = (selectedKeys, info) => {
    };

    onCheck = (checkedKeys, info) => {
        const checkedRows = this.state.groupListSearchIndexArray.filter((value) => {
            return checkedKeys.indexOf(value.uuid) > -1;
        });
        this.setState({
            checkedKeys: checkedKeys,
            checkedRows
        })
    };

    render() {
        const {visible, confirmLoading, ModalText, searchValue, expandedKeys, autoExpandParent} = this.state;


        return (
            <Modal
                className="common-modal select-target-form"
                title={<span><UserOutlined />&nbsp;対象グループの追加</span>}
                visible={this.state.visible}
                onOk={this.handleOk}
                maskClosable={false}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}>

                <div className="wrapper">
                    {this.state.loading ?
                        <div style={{padding:"50px",textAlign:"center"}}><LoadingOutlined /> グループ情報を読み込み中...</div> :
                        <Tree
                            checkable
                            checkedKeys={{checked:this.state.checkedKeys}}
                            onExpand={this.onExpand}
                            expandedKeys={expandedKeys}
                            autoExpandParent={true}
                            onSelect={this.onSelect}
                            onCheck={this.onCheck}>

                            {generate(this.state.groupListArray,searchValue)}

                        </Tree>
                    }
                    </div>
            </Modal>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddGroupModal)

